import { ButtonBlockProps } from '.';

export const transformButtonData = ({ params, href, ...data }: ButtonBlockProps) => {
  const prefix = params.venue ? `/${params.venuesPage}/${params.venue}` : '';

  return {
    ...data,
    href: href && !href?.includes('https://') ? `${prefix}${href}` : href,
  };
};
